import axios from 'axios'
import { getToken } from '@/api/login'
import router from '@/router'
import { UserModule } from '@/store/modules/user'

let adminURL
let appHOST
let headers = {}

if (!process.env.VUE_APP_ADMIN_URL) {
    alert('Env VUE_APP_ADMIN_URL is not set')

} else {
    adminURL = process.env.VUE_APP_ADMIN_URL
}

if (!process.env.VUE_APP_APP_HOST) {
    alert('Env VUE_APP_APP_HOST is not set')

} else {
    appHOST = process.env.VUE_APP_APP_HOST
}

if (getToken()) {
    headers = {
        Authorization: 'Bearer ' + getToken(),
    }
}

const HTTP = axios.create({
    baseURL: adminURL + 'api',
    headers,
})

/**
 * Force la déconnexion si une requete non authorisée est interceptée
 */
HTTP.interceptors.response.use(
    response => {
        return response
    },
    function(error) {
        if (
            /**
             * Permet de gérer l'erreur cross domain lors du retour depuis le page
             * inscription d'une ope vers generale
             */
            // error.response === undefined ||
            // Autres cas
            (error.response.status === 403 || error.response.status === 401) &&
            error.response.config.method === 'get'
        ) {
            UserModule.LogOut().then(() => {
                router.push({
                    name: 'signin',
                    query: {
                        from: 'logout',
                    },
                })
            })
        }
        return Promise.reject(error.response)
    }
)

export { HTTP }

export function getAppUrl(withPort = true) {
    return withPort ? appHOST : appHOST.replace(/:\d+$/, '')
}

export function getBoUrl() {
    return adminURL
}

export function getUrlParams() {
    const prmstr = window.location.search.substr(1)
    // params = params.split('&');
    const params = {}
    const prmarr = prmstr.split('&')
    for (let i = 0; i < prmarr.length; i++) {
        const tmparr = prmarr[i].split('=')
        params[tmparr[0]] = tmparr[1]
    }
    return params
}
